<template>
  <v-layout row wrap fill-height align-center justify-center class="secondary">
    <v-flex xs12 sm6 md4 lg5 xl2>
      <v-form ref="form" v-model="valid" lazy-validation>
        <!-- uid -->
        <input type="hidden" v-model="uid" value>

        <v-stepper v-model="step" svertical>
          <v-stepper-header>
            <v-stepper-step editable step="1">Register User</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step editable step="2">Account Type</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step editable step="3">Account Details</v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card class="mb-2" flat height="380">
                <!-- email -->
                <v-text-field
                  v-model="registerForm.email"
                  :rules="emailRules"
                  label="Email Address"
                  required
                ></v-text-field>

                <!-- password -->
                <v-text-field
                  v-model="registerForm.password"
                  :append-icon="showPass ? 'visibility' : 'visibility_off'"
                  :rules="[passrules.required, passrules.min]"
                  :ref="registerForm.password"
                  :type="showPass ? 'text' : 'password'"
                  label="Password"
                  hint="At least 8 characters"
                  @click:append="showPass = !showPass"
                ></v-text-field>

                <!-- re-password -->
                <v-text-field
                  v-model="registerForm.repassword"
                  :append-icon="showRepass ? 'visibility' : 'visibility_off'"
                  :rules="[passrules.required, passrules.min, passrules.match]"
                  :type="showRepass ? 'text' : 'password'"
                  label="Retype Password"
                  hint="At least 8 characters"
                  @click:append="showRepass = !showRepass"
                ></v-text-field>
              </v-card>

              <div class="right">
                <!-- <v-btn flat :to="'login'">Cancel</v-btn> -->
                <v-btn color="primary" @click="step = 2">Continue</v-btn>
                <v-btn :disabled="!valid" color="success" @click="handleRegister()">Submit</v-btn>
              </div>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card class="mb-2" flat>
                <!-- type [agent,  business] -->
                <v-select
                  v-model="registerForm.type"
                  :items="types"
                  item-text="text"
                  item-value="value"
                  label="Registrant Type"
                ></v-select>

                <!-- name -->
                <v-text-field v-model="registerForm.name" label="Business Name (optional)"></v-text-field>

                <!-- domain -->
                <v-text-field
                  v-model="registerForm.domain"
                  :rules="requiredField"
                  label="Domain Name"
                ></v-text-field>

                <!-- is_primary -->
                <v-checkbox
                  v-model="registerForm.isPrimary"
                  label="Check if you are a primary account holder"
                ></v-checkbox>
              </v-card>

              <div class="v-card__actions">
                <span class="error--text" v-if="errorMsg" v-html="errorMsg"></span>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="step = 1">Back</v-btn>
                <v-btn color="primary" @click="step = 3">Continue</v-btn>
                <v-btn :disabled="!valid" color="success" @click="handleRegister()">Submit</v-btn>
              </div>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card class="mb-5">
                <v-layout row wrap>
                  <v-flex md5>
                    <!-- first -->
                    <v-text-field
                      v-model="registerForm.first"
                      :rules="requiredField"
                      label="First Name"
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex md6 offset-md1>
                    <!-- last -->
                    <v-text-field
                      v-model="registerForm.last"
                      :rules="requiredField"
                      label="Last Name"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <!-- address1 -->
                <v-text-field
                  v-model="registerForm.address1"
                  :rules="requiredField"
                  label="Address"
                  required
                ></v-text-field>

                <!-- address2 -->
                <v-text-field v-model="registerForm.address2" label="Address (optional)"></v-text-field>

                <v-layout row wrap>
                  <v-flex md5>
                    <!-- country -->
                    <v-select
                      v-model="registerForm.country"
                      :items="countries"
                      item-text="name"
                      item-value="id"
                      @change="updateCountry"
                      label="Country"
                    ></v-select>
                  </v-flex>
                  <v-flex md6 offset-md1 v-if="registerForm.country">
                    <!-- state -->
                    <v-autocomplete
                      v-model="registerForm.state"
                      :items="filteredStates"
                      item-text="name"
                      item-value="id"
                      flat
                      hide-no-data
                      hide-details
                      v-if="registerForm.country !== 1"
                      label="State"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex md5 v-if="registerForm.state">
                    <!-- city -->
                    <v-autocomplete
                      v-model="registerForm.city"
                      :items="filteredCities"
                      item-text="name"
                      item-value="id"
                      flat
                      hide-no-data
                      hide-details
                      @change="updateCity"
                      label="City"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex md6 offset-md1 v-if="registerForm.city">
                    <!-- city -->
                    <v-autocomplete
                      v-model="registerForm.neighborhood"
                      :items="filteredNeighborhoods"
                      item-text="name"
                      item-value="id"
                      flat
                      hide-no-data
                      hide-details
                      v-if="registerForm.country !== 1"
                      label="Neighborhood"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md5 v-if="registerForm.city">
                    <!-- zipcode -->
                    <v-text-field
                      v-model="registerForm.zipcode"
                      :rules="requiredField"
                      label="Zipcode"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card>

              <div class="v-card__actions">
                <span class="error--text" v-if="errorMsg" v-html="errorMsg"></span>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="step = 2">Back</v-btn>
                <v-btn :disabled="!valid" color="success" @click="handleRegister()">Submit</v-btn>
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-form>
    </v-flex>
  </v-layout>
</template>
<script>
import {
  getCountries,
  getStates,
  getCities,
  getNeighborhoods
} from "../api/geo";
import { register } from "../api/user";
export default {
  name: "Register",
  data: () => ({
    step: 1,
    valid: false,
    errorMsg: "",
    uid: null,
    loading: false,
    search: null,
    registerForm: {
      email: "",
      password: "",
      repassword: "",
      isPrimary: false,
      domain: "",
      name: "",
      first: "",
      last: "",
      address1: "",
      address2: "",
      neighborhood: "",
      city: "",
      state: "",
      country: 1,
      zipcode: "",
      type: "agent"
    },
    showPass: false,
    showRepass: false,
    requiredField: [v => !!v || "This is a required field"],
    nameRules: [
      v => !!v || "Username is required",
      v => (v && v.length <= 10) || "Name must be less than 10 characters"
    ],
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ],
    countries: [],
    states: [],
    cities: [],
    neighborhoods: [],
    next: false
  }),
  computed: {
    passrules() {
      return {
        required: value => !!value || "Required.",
        min: v => v.length >= 8 || "Min 8 characters",
        match: v => v === this.registerForm.password || "Passwords do not match"
      };
    },
    filteredStates() {
      console.log("state", this.registerForm.country);
      return this.states.filter(state => {
        return state.country_id === this.registerForm.country;
      });
    },
    filteredCities() {
      console.log("city", this.registerForm.state);
      return this.cities.filter(city => {
        return city.state_id === this.registerForm.state;
      });
    },
    filteredNeighborhoods() {
      console.log("neighborhood", this.registerForm.city);
      return this.neighborhoods.filter(neighborhood => {
        return neighborhood.city_id === this.registerForm.city;
      });
    },
    types() {
      return [
        { value: "agent", text: "Agent" },
        { value: "business", text: "Business" }
      ];
    }
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    updateCountry() {
      this.registerForm.city = null;
      this.registerForm.neighborhood = null;
      if (this.registerForm.country === 1) {
        this.registerForm.state = 1;
      }
    },
    updateCity() {
      if (this.registerForm.country === 1) {
        this.registerForm.neighborhood = this.filteredNeighborhoods[0].id;
      }
    },
    async handleRegister() {
      register(this.registerForm).then(response => {
        if (response.error) {
          this.errorMsg = response.error;
        }
      });
    }
  },
  async created() {
    this.uid = this.$route.query.u;
    let c = await getCountries();
    this.countries = c.data;
    let s = await getStates();
    this.states = s.data;
    let c1 = await getCities();
    this.cities = c1.data;
    let n = await getNeighborhoods();
    this.neighborhoods = n.data;
  }
};
</script>